// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   FaBuilding,
//   FaTrashAlt,
//   FaEdit,
//   FaEye,
//   FaPlus,
//   FaSpinner,
// } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL!;

// interface CompanyItem {
//   id: string | number;
//   company_name: string;
//   email: string;
//   address: string;
//   city?: string;
//   state?: string;
//   country?: string;
//   gst_number?: string;
//   pancard?: string;
//   signature?: string;
// }

// const Company: React.FC = () => {
//   const [companies, setCompanies] = useState<CompanyItem[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [deleteLoading, setDeleteLoading] = useState<string | null>(null);
//   const [error, setError] = useState<string>("");
//   const [success, setSuccess] = useState<string>("");
//   const [deleteModal, setDeleteModal] = useState<null | CompanyItem>(null);

//   const navigate = useNavigate();

//   // Fetch list
//   useEffect(() => {
//     setLoading(true);
//     setError("");
//     axios
//       .get(`${API_URL}/companyAuth/companies`)
//       .then((res) => {
//         setCompanies(Array.isArray(res.data) ? res.data : (res.data?.companies || []));
//       })
//       .catch(() => setError("Failed to load companies."))
//       .finally(() => setLoading(false));
//   }, [success]);

//   const handleDelete = async (company: CompanyItem) => {
//     setDeleteLoading(`${company.id}`);
//     setError("");
//     try {
//       await axios.delete(`${API_URL}/companyauth/company/${company.id}`);
//       setSuccess("Company deleted successfully!");
//       setCompanies((prev) => prev.filter((comp) => comp.id !== company.id));
//       setDeleteModal(null);
//     } catch (e) {
//       setError("Could not delete company.");
//     } finally {
//       setDeleteLoading(null);
//     }
//   };

//   return (
//     <div className="max-w-5xl mx-auto px-2 py-10 animate__animated animate__fadeIn">
//       <div className="flex items-center justify-between mb-6">
//         <h1 className="text-3xl font-bold text-blue-900 flex items-center gap-2">
//           <FaBuilding className="text-blue-700" /> Companies
//         </h1>
//         <button
//           className="flex items-center gap-2 bg-blue-700 text-white px-6 py-3 rounded-xl font-bold text-lg hover:bg-blue-800 transition"
//           onClick={() => navigate("/admin/add-company?company_id=new")}
//         >
//           <FaPlus /> Add Company
//         </button>
//       </div>
//       {error && (
//         <div className="mb-4 p-4 text-red-700 bg-white border border-red-300 rounded-xl font-bold flex items-center gap-2">
//           <FaTrashAlt className="text-red-700" /> {error}
//         </div>
//       )}
//       {success && (
//         <div className="mb-4 p-4 text-blue-800 bg-white border border-blue-400 rounded-xl font-bold flex items-center gap-2">
//           <FaBuilding className="text-blue-700" /> {success}
//         </div>
//       )}
//       <div className="overflow-x-auto bg-white rounded-2xl shadow-lg border border-blue-200">
//         <table className="min-w-full divide-y divide-blue-100">
//           <thead className="bg-blue-50">
//             <tr>
//               <th className="px-6 py-4 text-left text-lg font-bold text-blue-700 whitespace-nowrap">
//                 Company
//               </th>
//               <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
//                 Email
//               </th>
//               <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
//                 Address
//               </th>
//               <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
//                 GST No.
//               </th>
//               <th className="px-6 py-4 text-center text-base font-bold text-blue-700">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan={5} className="text-center py-10">
//                   <FaSpinner className="animate-spin text-xl inline mr-2" />
//                   Loading companies...
//                 </td>
//               </tr>
//             ) : companies.length === 0 ? (
//               <tr>
//                 <td colSpan={5} className="py-10 text-center text-black">
//                   No companies found. Add your first company!
//                 </td>
//               </tr>
//             ) : (
//               companies.map((company) => (
//                 <tr
//                   key={company.id}
//                   className="even:bg-blue-50 hover:bg-blue-100 transition"
//                 >
//                   <td className="px-6 py-5 font-bold text-blue-900 flex items-center gap-2 whitespace-nowrap">
//                     <FaBuilding className="inline text-blue-700" />
//                     <span>{company.company_name}</span>
//                   </td>
//                   <td className="px-6 py-5 text-blue-900 font-medium">
//                     {company.email || <span className="text-black/40 italic">-</span>}
//                   </td>
//                   <td className="px-6 py-5 text-blue-900 line-clamp-2 max-w-xs">
//                     {company.address || <span className="text-black/40 italic">-</span>}
//                   </td>
//                   <td className="px-6 py-5 text-blue-900 font-semibold">
//                     {company.gst_number || <span className="text-black/40 italic">-</span>}
//                   </td>
//                   <td className="px-6 py-5 text-center">
//                     <div className="flex gap-2 justify-center">
//                       <button
//                         className="bg-white text-blue-800 px-3 py-2 rounded-lg font-bold hover:bg-blue-50 border border-blue-200 shadow transition"
//                         title="View"
//                         onClick={() => navigate(`/company/view?company_id=${company.id}`)}
//                       >
//                         <FaEye />
//                       </button>
//                       <button
//                         className="bg-white text-blue-700 px-3 py-2 rounded-lg font-bold hover:bg-blue-100 border border-blue-300 shadow transition"
//                         title="Edit"
//                         onClick={() => navigate(`/admin/add-company?company_id=${company.id}`)}
//                       >
//                         <FaEdit />
//                       </button>
//                       <button
//                         className="bg-white text-red-700 px-3 py-2 rounded-lg font-bold hover:bg-red-100 border border-red-200 shadow transition"
//                         disabled={deleteLoading === String(company.id)}
//                         title="Delete"
//                         onClick={() => setDeleteModal(company)}
//                       >
//                         {deleteLoading === String(company.id) ? (
//                           <FaSpinner className="animate-spin" />
//                         ) : (
//                           <FaTrashAlt />
//                         )}
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//       {deleteModal && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[120] animate__animated animate__fadeIn">
//           <div className="bg-white p-6 md:p-10 rounded-3xl shadow-2xl border border-blue-200 w-full max-w-sm">
//             <div className="mb-8 text-2xl font-bold text-red-700 flex items-center gap-2">
//               <FaTrashAlt className="text-red-700" />
//               Delete Company
//             </div>
//             <div className="mb-8 text-black font-medium">
//               Are you sure you want to delete <span className="font-bold">{deleteModal.company_name}</span>?
//             </div>
//             <div className="flex gap-4 justify-end">
//               <button
//                 onClick={() => setDeleteModal(null)}
//                 disabled={!!deleteLoading}
//                 className="px-7 py-2.5 bg-white hover:bg-blue-50 rounded-xl font-bold text-black border border-blue-100 shadow"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => handleDelete(deleteModal)}
//                 disabled={!!deleteLoading}
//                 className="px-7 py-2.5 bg-red-700 text-white rounded-xl font-black shadow-lg hover:bg-red-800 transition"
//               >
//                 {deleteLoading === String(deleteModal.id) ? (
//                   <FaSpinner className="animate-spin inline" />
//                 ) : (
//                   "Delete"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Company;
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaBuilding,
  FaTrashAlt,
  FaEdit,
  FaEye,
  FaPlus,
  FaSpinner,
  FaSearch,
  FaTimes,
} from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL!;

interface CompanyItem {
  id: string | number;
  company_name: string;
  email: string;
  address: string;
  city?: string;
  state?: string;
  country?: string;
  gst_number?: string;
  pancard?: string;
  signature?: string;
}

const Company: React.FC = () => {
  const [companies, setCompanies] = useState<CompanyItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<string | null>(null);
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [deleteModal, setDeleteModal] = useState<null | CompanyItem>(null);
  const [search, setSearch] = useState<string>("");

  const navigate = useNavigate();

  // Fetch list
  useEffect(() => {
    setLoading(true);
    setError("");
    axios
      .get(`${API_URL}/companyAuth/companies`)
      .then((res) => {
        setCompanies(Array.isArray(res.data) ? res.data : (res.data?.companies || []));
      })
      .catch(() => setError("Failed to load companies."))
      .finally(() => setLoading(false));
  }, [success]);

  const handleDelete = async (company: CompanyItem) => {
    setDeleteLoading(`${company.id}`);
    setError("");
    try {
      await axios.delete(`${API_URL}/companyauth/company/${company.id}`);
      setSuccess("Company deleted successfully!");
      setCompanies((prev) => prev.filter((comp) => comp.id !== company.id));
      setDeleteModal(null);
    } catch (e) {
      setError("Could not delete company.");
    } finally {
      setDeleteLoading(null);
    }
  };

  // Search-filtered companies — matches name, email, address, city,
  // state, country, and GST number, case-insensitive
  const filteredCompanies = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return companies;
    return companies.filter((company) => {
      const haystack = [
        company.company_name,
        company.email,
        company.address,
        company.city,
        company.state,
        company.country,
        company.gst_number,
      ]
        .filter(Boolean)
        .map((v) => String(v).toLowerCase())
        .join(" ");
      return haystack.includes(q);
    });
  }, [companies, search]);

  return (
    <div className="max-w-5xl mx-auto px-2 py-10 animate__animated animate__fadeIn">
      <div className="flex items-center justify-between mb-6 gap-4 flex-wrap">
        <h1 className="text-3xl font-bold text-blue-900 flex items-center gap-2">
          <FaBuilding className="text-blue-700" /> Companies
        </h1>
        <button
          className="flex items-center gap-2 bg-blue-700 text-white px-6 py-3 rounded-xl font-bold text-lg hover:bg-blue-800 transition"
          onClick={() => navigate("/admin/add-company?company_id=new")}
        >
          <FaPlus /> Add Company
        </button>
      </div>

      <div className="mb-6 relative max-w-md">
        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name, email, address, GST no…"
          className="w-full pl-11 pr-10 py-3 rounded-xl border border-blue-200 bg-white text-blue-900 font-medium shadow focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        {search && (
          <button
            type="button"
            onClick={() => setSearch("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-blue-400 hover:text-blue-700"
            aria-label="Clear search"
            title="Clear search"
          >
            <FaTimes />
          </button>
        )}
      </div>

      {error && (
        <div className="mb-4 p-4 text-red-700 bg-white border border-red-300 rounded-xl font-bold flex items-center gap-2">
          <FaTrashAlt className="text-red-700" /> {error}
        </div>
      )}
      {success && (
        <div className="mb-4 p-4 text-blue-800 bg-white border border-blue-400 rounded-xl font-bold flex items-center gap-2">
          <FaBuilding className="text-blue-700" /> {success}
        </div>
      )}
      <div className="overflow-x-auto bg-white rounded-2xl shadow-lg border border-blue-200">
        <table className="min-w-full divide-y divide-blue-100">
          <thead className="bg-blue-50">
            <tr>
              <th className="px-6 py-4 text-left text-lg font-bold text-blue-700 whitespace-nowrap">
                Company
              </th>
              <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
                Email
              </th>
              <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
                Address
              </th>
              <th className="px-6 py-4 text-left text-base font-bold text-blue-700">
                GST No.
              </th>
              <th className="px-6 py-4 text-center text-base font-bold text-blue-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="text-center py-10">
                  <FaSpinner className="animate-spin text-xl inline mr-2" />
                  Loading companies...
                </td>
              </tr>
            ) : filteredCompanies.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-10 text-center text-black">
                  {search
                    ? "No companies match your search."
                    : "No companies found. Add your first company!"}
                </td>
              </tr>
            ) : (
              filteredCompanies.map((company) => (
                <tr
                  key={company.id}
                  className="even:bg-blue-50 hover:bg-blue-100 transition"
                >
                  <td className="px-6 py-5 font-bold text-blue-900 flex items-center gap-2 whitespace-nowrap">
                    <FaBuilding className="inline text-blue-700" />
                    <span>{company.company_name}</span>
                  </td>
                  <td className="px-6 py-5 text-blue-900 font-medium">
                    {company.email || <span className="text-black/40 italic">-</span>}
                  </td>
                  <td className="px-6 py-5 text-blue-900 line-clamp-2 max-w-xs">
                    {company.address || <span className="text-black/40 italic">-</span>}
                  </td>
                  <td className="px-6 py-5 text-blue-900 font-semibold">
                    {company.gst_number || <span className="text-black/40 italic">-</span>}
                  </td>
                  <td className="px-6 py-5 text-center">
                    <div className="flex gap-2 justify-center">
                      <button
                        className="bg-white text-blue-800 px-3 py-2 rounded-lg font-bold hover:bg-blue-50 border border-blue-200 shadow transition"
                        title="View"
                        onClick={() => navigate(`/company/view?company_id=${company.id}`)}
                      >
                        <FaEye />
                      </button>
                      <button
                        className="bg-white text-blue-700 px-3 py-2 rounded-lg font-bold hover:bg-blue-100 border border-blue-300 shadow transition"
                        title="Edit"
                        onClick={() => navigate(`/admin/add-company?company_id=${company.id}`)}
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="bg-white text-red-700 px-3 py-2 rounded-lg font-bold hover:bg-red-100 border border-red-200 shadow transition"
                        disabled={deleteLoading === String(company.id)}
                        title="Delete"
                        onClick={() => setDeleteModal(company)}
                      >
                        {deleteLoading === String(company.id) ? (
                          <FaSpinner className="animate-spin" />
                        ) : (
                          <FaTrashAlt />
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {deleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[120] animate__animated animate__fadeIn">
          <div className="bg-white p-6 md:p-10 rounded-3xl shadow-2xl border border-blue-200 w-full max-w-sm">
            <div className="mb-8 text-2xl font-bold text-red-700 flex items-center gap-2">
              <FaTrashAlt className="text-red-700" />
              Delete Company
            </div>
            <div className="mb-8 text-black font-medium">
              Are you sure you want to delete <span className="font-bold">{deleteModal.company_name}</span>?
            </div>
            <div className="flex gap-4 justify-end">
              <button
                onClick={() => setDeleteModal(null)}
                disabled={!!deleteLoading}
                className="px-7 py-2.5 bg-white hover:bg-blue-50 rounded-xl font-bold text-black border border-blue-100 shadow"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDelete(deleteModal)}
                disabled={!!deleteLoading}
                className="px-7 py-2.5 bg-red-700 text-white rounded-xl font-black shadow-lg hover:bg-red-800 transition"
              >
                {deleteLoading === String(deleteModal.id) ? (
                  <FaSpinner className="animate-spin inline" />
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Company;